<template>
    <tci-title class="sign_title" title="2020苏州大宇宙客户大会" :subtitle="subtitle"  :color="color">
        <v-row v-if="subtitle == '报名通道'">
            <v-spacer></v-spacer>
            <v-col class="pa-0">
                <!-- 非手机端 -->
                <v-img
                        position="left top"
                        width="580"
                        height="530" class="d-none d-sm-flex"
                >
                    <v-row class="mx-2">
                        <v-col class="px-2">
                            <v-row >
                                <v-col class="py-1">
                                    <v-text-field background-color="rgb(255, 255, 255, 0.4)" label="姓名 *" v-model="name" require dense ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row >
                                <v-col class="py-1">
                                    <v-text-field  background-color="rgb(255, 255, 255, 0.4)" label="邮箱" v-model="email" require dense ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row >
                                <v-col class="py-1">
                                    <v-text-field background-color="rgb(255, 255, 255, 0.4)" label="电话号码 *" v-model="tel" require dense ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row >
                                <v-col class="py-1">
                                    <v-text-field background-color="rgb(255, 255, 255, 0.4)" label="公司名称 *" v-model="company" require dense ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row >
                                <v-col class="py-1">
                                    <v-text-field background-color="rgb(255, 255, 255, 0.4)" label="职务 *" v-model="position" require dense ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mx-0 my-2">
                                <v-btn color="rgb(33 74 101 / 88%)" class="py-2 sign_submin white--text" @click="contact" block>提 交</v-btn>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-img>
                <!-- 手机端 -->
                <v-img
                        position="left top"
                        class="d-flex d-sm-none"
                        width="980"
                        height="530"

                >
                    <v-card color="transparent" flat>
                    </v-card>

                    <v-row class="mt-0">
                        <v-col class="px-2">
                            <v-row >
                                <v-col class="py-1" cols="12">
                                    <v-text-field class="px-4" background-color="rgb(255, 255, 255, 0.1)" label="姓名 *" v-model="name" require dense ></v-text-field>
                                </v-col>
                                <v-col class="py-1" cols="12">
                                    <v-text-field class="px-4" background-color="rgb(255, 255, 255, 0.1)" label="邮箱" v-model="email" require dense ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-1" cols="12">
                                    <v-text-field class="px-4" background-color="rgb(255, 255, 255, 0.1)" label="电话号码 *" v-model="tel" dense ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row >
                                <v-col class="py-1" cols="12">
                                    <v-text-field class="px-4" background-color="rgb(255, 255, 255, 0.1)" label="公司名称 *" v-model="company" require dense ></v-text-field>
                                </v-col>
                                <v-col class="py-1" cols="12">
                                    <v-text-field class="px-4" background-color="rgb(255, 255, 255, 0.1)" label="职务 *" v-model="position" require dense ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mx-8 my-8">
                                <v-btn color="rgb(33 74 101 / 88%)" class="py-1 sign_submin white--text" @click="contact" block>提 交</v-btn>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-img>
            </v-col>
            <v-spacer></v-spacer>
        </v-row>
    </tci-title>
</template>

<script>

    import TciTitle from "@/components/TciTitle.vue";
    import axios from "axios";
    //双垒打
    var inputClick = true;
    export default {
        name: 'SignUp',
        components: {
            "tci-title": TciTitle,
        },
        data: () => ({
            name:"",
            email:"",
            tel:"",
            company:"",
            position:"",
            subtitle:"报名通道"
        }),
        props: {
            "color": String
        },
        mounted: function(){
            this.getShow();
        },
        methods: {
            getShow: function(){
                var _this = this;
                var date = new Date();
                //报名结束 调查页面迁移
                var endDate = new Date("2020-10-30");
                if (date.getTime() - endDate.getTime() < 0) {
                    _this.subtitle = "报名通道";
                } else {
                    this.$router.push('/seminar/survey.html')
                }
            },
            contact: function(){
                //空值 用来if语句过度
                var telFlag = false;
                //重新定义
                var _this = this;
                //获取值
                var name = _this.name;
                var email = _this.email;
                var tel = _this.tel;
                var company = _this.company;
                var position = _this.position;

                //验证
                if(!name){
                    _this.$message({
                        message: '请输入姓名',
                        type: 'error',
                        offset:300,
                        duration:1000
                    });
                    return false;
                }else if(!tel){
                    _this.$message({
                        message: '请输入电话号码',
                        type: 'error',
                        offset:300,
                        duration:1000
                    });
                    return false;
                }else if(!company){
                    _this.$message({
                        message: '请输入公司名称',
                        type: 'error',
                        offset:300,
                        duration:1000
                    });
                    return false;
                }else if(!position){
                    _this.$message({
                        message: '请输入职务',
                        type: 'error',
                        offset:300,
                        duration:1000
                    });
                    return false;
                }

                /*if(email != "") {
                    var reg = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
                    var isok= reg.test(email );
                    if (!isok) {
                        _this.$message({
                            message: '邮箱格式不正确，请重新输入！',
                            type: 'error',
                            offset:300,
                            duration:1000
                        });
                        return false;
                    }
                }*/
                if(tel != ""){
                    var rex = /^1[3-9]+\d{9}$/;
                    var rex2 = /^((0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/;
                    if (rex.test(tel) || rex2.test(tel)) {
                        telFlag = true;
                    } else {
                        _this.$message({
                            message: '电话号码格式不正确，请重新输入！',
                            type: 'error',
                            offset:300
                        });
                        return false;
                    }
                }
                //api参数
                var params = new URLSearchParams();
                params.append('name',name);
                params.append('email', email);
                params.append('tel', tel);
                params.append('company', company);
                params.append('position', position);
                params.append('telFlag', telFlag);
                if(inputClick){
                    inputClick = false;
                    //调用api
                    //axios.post('http://172.16.1.153:9060/signUp/seminar/signUpPostApi.php', params)
                    axios.post('http://58.240.228.70:8068/seminar/signUpPostApi.php', params)
                        .then(function (result) {
                            inputClick = true;
                            //返回结果
                            if(result.data.res == 1){
                                _this.$message({
                                    showClose: true,
                                    message: result.data.mes,
                                    type: 'success',
                                    offset:300
                                });
                                //成功清空输入框
                                _this.name = "";
                                _this.email = "";
                                _this.tel = "";
                                _this.company = "";
                                _this.position = "";
                            }else{
                                _this.$message({
                                    showClose: true,
                                    message: result.data.mes,
                                    type: 'error',
                                    offset:300
                                });
                            }
                        })
                        .catch(function (error) { // 请求失败处理
                            inputClick = true;
                            console.log(error);
                        })
                }

            }

        }

    }
</script>
<style>
    .sign_submin span{
        font-weight: 500;
        font-size: 1.2rem;
    }

    .sign_title  .v-card__title{
        font-size: 2rem !important;
    }

    .sign_title  .v-card__subtitle{
        font-size: 1.5rem !important;
    }

    .sign_submin{
        background-color: rgba(33, 74, 101, 0.88) !important;
        border-color: rgba(33, 74, 101, 0.88) !important;
    }
    @media (max-width: 750px){
        .sign_title  .v-card__title{
            font-size: 1.8rem !important;
        }
        .sign_submin{
            height: 40px !important;
        }
    }
</style>